<asg-floating-menu [menuItem]="AsgardFeatureNames.TOOLBAR_MENU">
  <mat-divider></mat-divider>
  @if (style) {
    <ul>
      <li
        [asgClickHandler]="switchNotesMode"
        [asgClickParams]="AsgardFeatureNames.TEXT_NOTES"
        [ngClass]="{
        'disabled': uiState[AsgardFeatureNames.TEXT_NOTES].disabled,
        'hidden': uiState[AsgardFeatureNames.TEXT_NOTES].hidden,
        'active': uiState[AsgardFeatureNames.TEXT_NOTES].active,
        'multi': multiNoteCreationText
        }" asgTooltip="TOOLBARS.TEXT_NOTES">
        <i class="fas fa-text"></i>
      </li>
      <li
        [asgClickHandler]="switchNotesMode"
        [asgClickParams]="AsgardFeatureNames.STICKY_NOTES"
       [ngClass]="{
        'disabled': uiState[AsgardFeatureNames.STICKY_NOTES].disabled,
        'hidden': uiState[AsgardFeatureNames.STICKY_NOTES].hidden,
        'active': uiState[AsgardFeatureNames.STICKY_NOTES].active,
        'multi': multiNoteCreationSticky
        }" asgTooltip="TOOLBARS.STICKY_NOTES">
        <i class="fal fa-sticky-note"></i>
      </li>
      <li
        [asgClickHandler]="toggleFeatureState"
        [asgClickParams]="AsgardFeatureNames.SHOW_TEXT_ANNOTATIONS"
         [ngClass]="{
        'disabled': uiState[AsgardFeatureNames.SHOW_TEXT_ANNOTATIONS].disabled,
        'hidden': uiState[AsgardFeatureNames.SHOW_TEXT_ANNOTATIONS].hidden,
        'active': uiState[AsgardFeatureNames.SHOW_TEXT_ANNOTATIONS].active
        }" >
        @if (!uiState[AsgardFeatureNames.SHOW_TEXT_ANNOTATIONS].active) {
          <i class="fas fa-eye" asgTooltip="TOOLBARS.HIDE_TEXT_ANNOTATIONS"></i>
        }
        @if (uiState[AsgardFeatureNames.SHOW_TEXT_ANNOTATIONS].active) {
          <i class="fas fa-eye-slash" asgTooltip="TOOLBARS.SHOW_TEXT_ANNOTATIONS"></i>
        }
      </li>
      <li
        [asgClickHandler]="deleteEmptyNotes"
        [ngClass]="{
        'disabled': uiState[AsgardFeatureNames.DELETE_EMPTY_TEXT_NOTES].disabled,
        'hidden': uiState[AsgardFeatureNames.DELETE_EMPTY_TEXT_NOTES].hidden,
        'active': uiState[AsgardFeatureNames.DELETE_EMPTY_TEXT_NOTES].active
        }" >
        <i class="far fa-trash" asgTooltip="TOOLBARS.DELETE_EMPTY_TEXT_NOTES"></i>
      </li>
      <mat-divider></mat-divider>
      <li class="floating-menu-toolbar--has-dropdown" asgTooltip="TOOLBARS.SELECT_ANOT_COLOR">
        <i class="fas fa-tint" [ngStyle]="{ 'color': style && style.color}"></i>
        <ul class="floating-menu-toolbar__dropdown choose-color">
          @for (strokeColor of strokeColors; track strokeColor) {
            <li
              [asgClickHandler]="selectColor"
              [asgClickParams]="strokeColor"
              [asgardFeature]="AsgardFeatureNames.TEXT_NOTE_STYLE"
          [ngStyle]="{ 'background-color': strokeColor }" [ngClass]="{
            'active': (style && style.color === strokeColor)
          }"></li>
          }
        </ul>
      </li>
      <li class="floating-menu-toolbar--has-dropdown" asgTooltip="TOOLBARS.SELECT_FONT_SIZE">
        {{ style.fontSize }} pt
        <ul class="floating-menu-toolbar__dropdown">
          @for (fontSize of fontSizes; track fontSize) {
<li [ngClass]="{
                'active': style && style.fontSize === fontSize
              }"
              [asgClickHandler]="selectFontSize"
              [asgClickParams]="fontSize"
              [asgardFeature]="AsgardFeatureNames.TEXT_NOTE_STYLE"
              >{{fontSize}}
            pt</li>
          }
        </ul>
      </li>
      <li class="floating-menu-toolbar--has-dropdown" asgTooltip="TOOLBARS.SELECT_FONT_FAMILY">
        <i class="fas fa-font"></i>
        <ul class="floating-menu-toolbar__dropdown">
          @for (font of fonts; track font) {
<li [ngClass]="{
                  'active':  (style && style.fontFamily.title === font.title )
                }" [ngStyle]="{'fontFamily': font.value}"
              [asgClickHandler]="selectFontFamily"
              [asgClickParams]="font"
              [asgardFeature]="AsgardFeatureNames.TEXT_NOTE_STYLE"
              >{{font.title}}
            </li>
          }
        </ul>
      </li>
    </ul>
  }
  <mat-divider></mat-divider>
</asg-floating-menu>
